import React from "react";
import ReactTable from "react-table";

import * as notify from "../../shared/notify";

import Modal from "../modal";
import eventEmitter from "../../shared/events";
import LoaderButton from "../loader/loader-button";
import ImageUploader from "../form-inputs/imageUploader";

import { Textarea } from "../form-inputs/inputs";
import { getAttachments, addAttachment } from "./lib/resourceData";
import ResourceDetail from "./resource-detail";
import { EVENT_VIEW_ATTACHMENT, EVENT_REFRESH_ATTACHMENTS } from "./lib/constants";

class ShipmentResources extends React.Component {
    constructor() {
        super();

        this.state = {
            attachments: [],
            currentNote: "",
            currentAttachment: {},
            files: [],
            isSubmitting: false,
            isReadOnly: false,
        };
    }
    componentDidMount() {
        this.getAttachmentData();
        eventEmitter.on(EVENT_VIEW_ATTACHMENT, this.showAttachment);
        eventEmitter.on(EVENT_REFRESH_ATTACHMENTS, this.getAttachmentData);
    }

    componentWillUnmount() {
        eventEmitter.removeListener(EVENT_VIEW_ATTACHMENT, this.showAttachment);
        eventEmitter.removeListener(EVENT_REFRESH_ATTACHMENTS, this.getAttachmentData);
    }

    showAttachment = (attachment) => {
        this._showModal(attachment);
    };

    getAttachmentData = async () => {
        const attachments = await getAttachments(this.props.id);
        this.setState({
            attachments,
            currentAttachment: {},
            showModal: false,
            isReadOnly: this.props.disableAdd,
        });
    };

    updateFile = (files) => {
        const file = files && files.length > 0 ? files[0] : null;
        this.setState({
            file: file,
        });
    };

    updateState = (name, value) => {
        this.setState({
            [`${name}`]: value,
        });
    };

    saveResource = async () => {
        const file = this.state.file;

        if (!file) {
            notify.warning("Please select a file to add.");

            return;
        }

        this.setState({
            isSubmitting: true,
        });

        const formData = new FormData();
        formData.append("name", file.name);
        formData.append("notes", this.state.currentNote);
        formData.append("file", file);

        const addedAttachment = await addAttachment(this.props.id, formData);

        if (!addedAttachment) {
            this.setState({
                isSubmitting: false,
            });

            return;
        }

        notify.success("Saved!");
        this.setState({
            currentNote: "",
            file: null,
            isSubmitting: false,
        });

        this.getAttachmentData();
    };

    onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: (e) => {
                // const clicked = rowInfo.original;
                eventEmitter.emit(EVENT_VIEW_ATTACHMENT, rowInfo.original);
            },
        };
    };

    _showModal = (attachment) => {
        this.setState({
            currentAttachment: attachment,
            showModal: true,
        });
    };
    _closeModal = () => {
        this.setState({
            currentAttachment: {},
            showModal: false,
        });
    };

    render() {
        const columns = () => {
            return [
                {
                    Header: "File Name",
                    accessor: "filename",
                },
                {
                    Header: "Notes",
                    accessor: "notes",
                },
                {
                    Header: "Date Added",
                    accessor: "date",
                },
            ];
        };

        return (
            <fieldset>
                <legend>Shipment Resources</legend>

                <div className="row">
                    <div className="column -span4">
                        <h3>Resource Details</h3>
                        <ImageUploader
                            file={this.state.file}
                            updateField={this.updateFile}
                            allowedFiles={[".doc", ".docx", ".jpg", ".jpeg", ".pdf", ".png", ".rtf", ".txt", ".xls", ".xlsx"]}
                            disabled={this.state.isReadOnly}
                        />
                        <Textarea
                            label="Resource Note"
                            name="currentNote"
                            value={this.state.currentNote}
                            updateOnChange={this.updateState}
                            disabled={this.state.isReadOnly}
                        />
                        <br />
                        <LoaderButton
                            className="button -full -primary"
                            onClick={this.saveResource}
                            isSubmitting={this.state.isSubmitting}
                            text="Add Resource to Shipment"
                            disabled={this.state.isReadOnly}
                        />
                    </div>
                    <div className="column -span8">
                        <ReactTable
                            data={this.state.attachments}
                            columns={columns()}
                            minRows="5"
                            showPagination={false}
                            getTrProps={this.onRowClick}
                        />
                        <Modal show={this.state.showModal} onClose={this._closeModal}>
                            <ResourceDetail shipmentKey={this.props.id} {...this.state.currentAttachment} />
                        </Modal>
                    </div>
                </div>
            </fieldset>
        );
    }
}

export default ShipmentResources;
